<template>
  <div class="container p-5">
    <form @submit.prevent="signin()">
      <h5 class="text-center">Member Login</h5>
      <div class="form-group">
        <label>Email</label> <i class="icon_mail_alt"></i>
        <input type="email" class="form-control" v-model="login.username" />
      </div>
      <div class="form-group">
        <label>Password</label> <i class="icon_lock_alt"></i>
        <input type="password" class="form-control" v-model="login.password" />
      </div>

      <div class="clearfix add_bottom_30">
        <div class="checkboxes float-left">
          <label class="container_check"
            >Remember me
            <input type="checkbox" />
            <span class="checkmark"></span>
          </label>
        </div>
        <div class="float-right mt-1">
          <router-link id="forgot" to="/forget-password"
            >Forgot Password?</router-link
          >
        </div>
      </div>
      <button
        type="submit"
        class="btn_1 rounded full-width"
        :disabled="loading"
      >
        <span v-show="loading" class="spinner-border spinner-border-sm"></span>
        Login
      </button>
      <div class="text-center add_top_10">
        New to Travel Friends?
        <router-link to="/signup"
          ><strong><a href="signup">Sign up!</a></strong></router-link
        >
      </div>
      <div class="text-center add_top_10">
        You became a Marchant Account?
        <router-link to="/merchant-signup"
          ><strong><a href="merchant-signup">Sign up!</a></strong></router-link
        >
      </div>
    </form>
  </div>
</template>

<script>
import API from "../services/index";
// import Registerlayout from "../layouts/Registerlayout.vue";
//import router from "../routes";

export default {
  data() {
    return {
      token: null,
      role_id: null,
      expires_in: null,
      login: {
        username: "",
        password: "",
        grant_type: "password",
      },
      loading: false,
    };
  },
  beforeMount() {
    this.checkToken();
  },
  components: {},
  methods: {
    checkToken() {
      const token = localStorage.getItem("token");
      const roleId = localStorage.getItem("role_id");
      if (token != null) {
        if (roleId != 3) {
          // console.log(roleId)
        } else {
          console.log(roleId);
          // this.$router.push("/my-account");
        }
      }
    },

    signin() {
      // const form = JSON.stringify(this.login);
      // console.log(form);
      this.loading = true;
      var formData = new FormData();
      formData.append("username", this.login.username);
      formData.append("password", this.login.password);
      formData.append("grant_type", "password");
      //form.append("grant_type", "password");
      API({
        method: "post",
        url: "user/login",
        data: formData,
        auth: {
          username: "testclient",
          password: "testsecret",
        },
      })
        .then((res) => {
          this.loading = false;
          console.log(res);
          this.login.email = "";
          this.login.passwordpassword = "";

          this.token = res.data.access_token;
          this.role_id = res.data.role_id;

          this.expires_in = res.data.expires_in;
          const expiresMs = this.expires_in * 1000;
          const now = new Date();
          const expireDate = new Date(now.getTime() + expiresMs);

          // router.push("/my-account");
          // alert(this.role_id);
          if (res.data.role_id == 2 || res.data.role_id == 3) {
            localStorage.setItem("token", this.token);
            localStorage.setItem("role_id", this.role_id);
            localStorage.setItem("expires", expireDate);
            localStorage.setItem("location", res.data.location_data.address);
            localStorage.setItem("pincode", res.data.location_data.pincode);
            localStorage.setItem("lat", res.data.location_data.lat);
            localStorage.setItem("lng", res.data.location_data.lng);
            localStorage.setItem(
              "user_status",
              res.data.location_data.is_active
            );
            this.$store.dispatch("login", expiresMs);
            /* eslint-disable no-mixed-spaces-and-tabs */
            window.$(".bd-example-modal-lg").modal("hide");
          } else {
            // alert('hello');
            this.$swal("Error", "Unauthorised Access");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$swal("Error", err.response.data.error_description);
        });
    },
  },
};
</script>
